import styled from "styled-components";

import { fadeIn, fadeOut } from "@/styles/Mixins";
import { IThemeProps } from "@/styles/Theme";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props: IThemeProps) => props.theme.colors.headerBackground};
  color: ${(props: IThemeProps) => props.theme.colors.headerFont};
  height: auto;
  padding: 15px;
  min-height: 110px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    min-height: 60px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  max-width: ${(props: IThemeProps) => props.theme.globals.maxInteractionWidth};
`;

export const Navigator = styled.div`
  flex-grow: 1;
  max-width: 40px;
  text-align: center;
  width: 15%;
  margin: 0 ${(props: IThemeProps) => props.theme.spacing.mobile.s500}px;
  cursor: pointer;
  svg,
  path {
    fill: ${(props: IThemeProps) => props.theme.colors.headerFont};
    circle {
      transition: all 0.25s linear;
    }
  }

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    max-width: 32px;
    svg {
      padding: 2px;
    }
  }

  ${(props: IThemeProps) =>
    !props.theme.globals.isTouch &&
    `&:hover {
            svg {
                circle {
                    opacity: 0.2;
                }
            }
        }
        &:active {
            svg {
                circle {
                    opacity: 0.5;
                }
            }
        }`}
`;

type TitleProps = IThemeProps<{ show: boolean }>;

export const Title = styled.h1<TitleProps>`
  font-family: ${(props: TitleProps) => props.theme.globals.fontFamilyExtra2};
  font-size: ${(props: TitleProps) => props.theme.typography.h710};
  font-weight: ${(props: TitleProps) => props.theme.globals.fontWeightBold};
  line-height: 1.3;
  text-align: center;
  flex-grow: 1;
  width: 70%;
  opacity: ${(props: TitleProps) => (props.show ? 1 : 0)};
  animation: ${(props: TitleProps) => (props.show ? fadeIn : fadeOut)} 150ms
    ease-in;

  @media ${(props: TitleProps) => props.theme.breakpoints.mobile} {
    font-size: ${(props: TitleProps) => props.theme.typography.h320};
  }
`;
